import React from 'react';
import styled, { css } from 'styled-components';
import { Body } from '~/components/atom/Typography';

export type Props = {};

const Description: React.FCC<Props> = ({ ...rest }) => (
  <Container>
    <Body {...rest} />
  </Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    margin-top: ${theme.space('s')};
    margin-bottom: ${theme.space('base')};
    line-height: ${theme.lineHeight('m')};
  `,
);

export default Description;
